import type { HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

const variants = {
  default: "bg-surface-raised text-foreground border-white/10",
  primary: "bg-primary/15 text-primary border-primary/30",
  success: "bg-success/15 text-success border-success/30",
  warning: "bg-warning/15 text-warning border-warning/30",
  danger: "bg-danger/15 text-danger border-danger/30",
  lavender: "bg-accent-lavender/15 text-accent-lavender border-accent-lavender/30",
  sage: "bg-accent-sage/15 text-accent-sage border-accent-sage/30",
  blush: "bg-accent-blush/15 text-accent-blush border-accent-blush/30",
} as const;

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: keyof typeof variants;
}

export function Badge({ className, variant = "default", ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
        "transition-colors duration-150",
        variants[variant],
        className,
      )}
      {...props}
    />
  );
}
